import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PageView = styled(Stack)(({ theme }) => ({
  position: "absolute",
  left: 0,
  top: theme.navbarSize,
  width: "100%",
  height: `calc(100% - ${theme.navbarSize})`,
}));
